import { PageDS, AddOutlined } from "@qivia/ui";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AddDepartmentModal } from "./modals/addDepartmentModal";

export const Departments = () => {
  const env = import.meta.env["VITE_TARGET_ENV"] as string;
  const navigate = useNavigate();

  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    if (env === "production") {
      navigate("/home");
    }
  }, [env, navigate]);

  const cta = {
    title: t("departments.cta"),
    action: () => {
      setIsModalVisible(true)
    },
    width: 12,
    leftIcon: <AddOutlined />,
  };

  return (
    <>
      <AddDepartmentModal
        visible={isModalVisible}
        onCloseModal={() => {
          setIsModalVisible(false);
        }}
      />
      <PageDS title={t(`departments.title`)} cta={cta}></PageDS>
    </>
  );
};
